import { AppBar, Tab, Tabs, Tooltip } from '@mui/material';
import { action, computed, makeObservable } from 'mobx';
import { inject, observer } from 'mobx-react';
import ReactComponent from '../ReactComponent';

class SelecaoProcessos extends ReactComponent {
    handleChangeProcessosEmExibicao = (idProcessosEmExibicao) => {
        this.store.alterarProcessosEmExibicao(idProcessosEmExibicao);
    };

    constructor(props) {
        super(props);

        makeObservable(this, {
            handleChangeProcessosEmExibicao: action,
            corTextoFiltroAtivo: computed,
            abaSelecionadaListaProcessos: computed,
            opcoesProcessosEmExibicao: computed
        });
    }

    get corTextoFiltroAtivo() {
        return this.store.existeFiltroAtivo ? 'secondary' : 'primary';
    }

    get abaSelecionadaListaProcessos() {
        let opcaoProcessosEmExibicao = this.opcoesProcessosEmExibicao.find(
            (opcaoProcessos) => opcaoProcessos.id === this.store.idProcessosEmExibicao
        );
        return opcaoProcessosEmExibicao ? opcaoProcessosEmExibicao.ordem : 0;
    }

    get opcoesProcessosEmExibicao() {
        return this.store.opcoesProcessosEmExibicao;
    }

    render() {
        return (
            <AppBar
                position="static"
                elevation={2}
                style={{ flexShrink: 1, alignSelf: 'flex-end', zIndex: 9 }}
            >
                <Tabs
                    value={this.abaSelecionadaListaProcessos}
                    textColor={this.corTextoFiltroAtivo}
                    indicatorColor={this.corTextoFiltroAtivo}
                    sx={this.estiloAbas}
                    variant="fullWidth"
                >
                    {this.opcoesProcessosEmExibicao.map((opcaoProcessosEmExibicao) =>
                        this.renderOpcao(opcaoProcessosEmExibicao)
                    )}
                </Tabs>
            </AppBar>
        );
    }

    get estiloAbas() {
        return {
            bgcolor: 'background.paper',
            minHeight: '36px',
            minWidth: '110px'
        };
    }

    renderOpcao(processosEmExibicao) {
        return (
            <Tab
                key={this.nextKey}
                onClick={() => this.handleChangeProcessosEmExibicao(processosEmExibicao.id)}
                sx={this.estiloAbas}
                label={
                    <Tooltip
                        placement="top"
                        title={this.getTooltip(processosEmExibicao)}
                    >
                        <div>{this.getDescricao(processosEmExibicao)}</div>
                    </Tooltip>
                }
            />
        );
    }

    getTooltip(processosEmExibicao) {
        return (
            'Total de processos ' +
            processosEmExibicao.descricao +
            ': ' +
            processosEmExibicao.funcaoProcessos().length +
            (this.store.existeFiltroAtivo
                ? ' \nQuantidade de processos ' +
                  processosEmExibicao.descricao +
                  ' filtrados: ' +
                  processosEmExibicao.funcaoProcessosFiltrados().length
                : '')
        );
    }

    getDescricao(processosEmExibicao) {
        return (
            this.capitalizar(processosEmExibicao.descricao) +
            ' (' +
            processosEmExibicao.funcaoProcessos().length +
            (this.store.existeFiltroAtivo ? ' F: ' + processosEmExibicao.funcaoProcessosFiltrados().length : '') +
            ')'
        );
    }

    capitalizar(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
}

export default inject('stores')(observer(SelecaoProcessos));
